<template>
  <div class="broadcasts">
    <Broadcast v-for="broadcast in broadcasts" :broadcast="broadcast" />
  </div>
</template>

<script setup>
import Broadcast from "./Broadcast.vue";

defineProps({
  broadcasts: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.broadcasts {
  &,
  > * + * {
    margin-top: var(--sp-comp-dtv-broadcasts-gap-row, 1rem) !important;
  }
}
</style>
